import Main from '@/components/main/Main';
// 支付模块的路由
export default [
  {
    name: 'dmp_monitor',
    path: '/dmp/monitor',
    component: Main,
    redirect: '/dmp/campaign',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '素材库',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'dmp_campaign',
        path: '/dmp/campaign',
        component: () => import('@/emc-dmp/views/dmpcampaign'),
        meta: {
          showInMenu: true,
          path: '/dmp/campaign',
          title: '推广活动管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_campaign_add',
        path: '/dmp/campaign/add',
        component: () => import('@/emc-dmp/views/dmpcampaign/EditPage'),
        meta: {
          showInMenu: false
        }
      }
    ]
  }
];
